export const MIN_IN_MS = 60 * 1000;
export const HOUR_IN_MS = 60 * MIN_IN_MS;
export const DAY_IN_MS = 24 * HOUR_IN_MS;

export const TIME_AGO_TRANSLATIONS_KEY = {
  TODAY: "TIME.TODAY",
  TOMORROW: "TIME.TOMORROW",
  YESTERDAY: "TIME.YESTERDAY",
} as const;
